import React from 'react';
import PropTypes from 'prop-types';
import {Col, Input, Row} from "antd";

class InputContact extends React.Component {
  state = this.props.value || {};

  handleFirstNameChange = e => {
    const firstName = e.target.value;
    this.handleChange({firstName});
  };

  handleLastNameChange = e => {
    const lastName = e.target.value;
    this.handleChange({lastName});
  };

  handlePhoneChange = e => {
    const phone = e.target.value;
    this.handleChange({phone});
  };

  handleEmailChange = e => {
    const email = e.target.value;
    this.handleChange({email});
  };

  handleChange = delta => {
    this.setState(delta);
    this.triggerChange(delta);
  };

  triggerChange = changedValue => {
    const {onChange} = this.props;
    if (onChange) {
      onChange({...this.state, ...changedValue});
    }
  };

  render() {
    const {firstName, lastName, phone, email} = this.state;
    return <Row gutter={16}>
      <Col span={24}><Input type="text" placeholder="First Name" value={firstName} onChange={this.handleFirstNameChange}/></Col>
      <Col span={24}><Input type="text" placeholder="Last Name" value={lastName} onChange={this.handleLastNameChange}/></Col>
      <Col span={24}><Input type="text" placeholder="Phone" value={phone} onChange={this.handlePhoneChange}/></Col>
      <Col span={24}><Input type="text" placeholder="Email" value={email} onChange={this.handleEmailChange}/></Col>
    </Row>;
  }
}

InputContact.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
};

export default InputContact;


// WEBPACK FOOTER //
// ./src/common/InputContact.js